import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BHQrCodeSiteScannerModel } from '../bh-qrcode-site-scanner.model';
import { MatDialog } from '@angular/material/dialog';
import { MdBhQrCodeSiteScannerMotifDialog } from '../bh-qrcode-site-scanner-form/@modals/md-bh-qrcode-site-scanner-motif-dialog/md-bh-qrcode-site-scanner-motif-dialog.component';

@Component({
    selector: 'abw-bh-qrcode-site-scanner-result',
    templateUrl: './bh-qrcode-site-scanner-result.component.html',
    styleUrls: ['./bh-qrcode-site-scanner-result.component.scss']
})
export class BHQrCodeSiteScannerResultComponent implements OnInit, OnChanges {
    @Input() model: BHQrCodeSiteScannerModel;
    @Input() value: any;

    constructor(
        private dialog: MatDialog,
    ) {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!!changes.value.currentValue) {
            console.log(this.value);
        }
    }

    openMotifDialog(agent: any) {
        this.dialog.open(MdBhQrCodeSiteScannerMotifDialog, {
            data: {
                dateControle: this.value.DATE_CONTROLE,
                site: { CODE_SITE: this.value.CODE_SITE, NOM_CLIENT: this.value.NOM_SITE },
                agent: agent,
                presence: this.value.PRESENCES[agent.ID],
                allAgents: [],
                motif: this.value.MOTIFS[agent.ID] || null,
                readonly: true
            },
            width: '100vw',
            panelClass: 'datasource-designer-modal'
        });
    }
}